var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-content",
    { staticClass: "pt-0 pl-0" },
    [
      _c("v-text-field", {
        staticClass: "address--line__1",
        attrs: {
          counter: 200,
          maxlength: 200,
          label: _vm.$t(_vm.lblSetting.member_form.address_label),
          required: _vm.required || _vm.coIsFieldNotEmpty,
          rules: _vm.dtRules.addressRules,
          solo: "",
          clearable: ""
        },
        model: {
          value: _vm.dtLine_1,
          callback: function($$v) {
            _vm.dtLine_1 = $$v
          },
          expression: "dtLine_1"
        }
      }),
      _vm._v(" "),
      _c("v-text-field", {
        staticClass: "address--line__2",
        attrs: {
          counter: 200,
          maxlength: 200,
          label: _vm.$t(_vm.lblSetting.member_form.address_secondary),
          solo: "",
          clearable: ""
        },
        model: {
          value: _vm.line_2,
          callback: function($$v) {
            _vm.line_2 = $$v
          },
          expression: "line_2"
        }
      }),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: {
          counter: 20,
          maxlength: 20,
          label: _vm.$t(_vm.lblSetting.member_form.code_postal),
          required: _vm.required || _vm.coIsFieldNotEmpty,
          rules: _vm.dtRules.codePostalRules,
          solo: ""
        },
        model: {
          value: _vm.postal_code,
          callback: function($$v) {
            _vm.postal_code = $$v
          },
          expression: "postal_code"
        }
      }),
      _vm._v(" "),
      _c("v-text-field", {
        staticClass: "address--city",
        attrs: {
          counter: 50,
          maxlength: 50,
          label: _vm.$t(_vm.lblSetting.member_form.city),
          required: _vm.required || _vm.coIsFieldNotEmpty,
          rules: _vm.dtRules.cityRules,
          solo: ""
        },
        model: {
          value: _vm.city,
          callback: function($$v) {
            _vm.city = $$v
          },
          expression: "city"
        }
      }),
      _vm._v(" "),
      _c("v-text-field", {
        staticClass: "address--country",
        attrs: {
          counter: 50,
          maxlength: 50,
          label: _vm.$t(_vm.lblSetting.member_form.country),
          required: _vm.required || _vm.coIsFieldNotEmpty,
          rules: _vm.dtRules.countryRules,
          solo: ""
        },
        model: {
          value: _vm.country,
          callback: function($$v) {
            _vm.country = $$v
          },
          expression: "country"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c0de948", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c0de948","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/address-fields/template.html
// module id = null
// module chunks = 